import { memo } from 'react';
import { useTheme } from '../../hooks/useTheme';
import {
  SkeletonCircle,
  SkeletonLine,
  SkeletonPill,
} from '../common/Skeleton.web';

interface LibraryListSkeletonProps {
  count?: number;
}

export const LibraryListSkeleton = memo(function LibraryListSkeleton({
  count = 6,
}: LibraryListSkeletonProps) {
  const { theme, isDark } = useTheme();

  return (
    <div
      style={{
        overflow: 'hidden',
        borderRadius: 28,
        border: `1px solid ${theme.borderSubtle}`,
        backgroundColor: isDark ? theme.surfaceElevated : 'rgba(255,255,255,0.82)',
      }}
    >
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={`library-row-skeleton-${index}`}
          style={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 12,
            padding: 16,
            borderBottom:
              index === count - 1 ? 'none' : `1px solid ${theme.borderSubtle}`,
          }}
        >
          <SkeletonCircle size={44} />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 8 }}>
            <SkeletonLine width="58%" height={15} />
            <SkeletonLine width="42%" height={12} />
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              <SkeletonPill width={56} />
              <SkeletonPill width={64} />
              <SkeletonPill width={48} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
});
